import { initScrollSmoother } from "./site/scrollSmoother";

import { initCookieConsent } from "./vendor/cookieConsent";

import { heroRotator } from "./components/heroRotator";
import { sliderGallery } from "./components/sliderGallery";
import { sliderVertical } from "./components/sliderVertical";

import { handleHamburgerClick } from "./triggers/triggerHamburger";
import { floaterMove, floaterShowHide, handleImageFloater } from "./triggers/triggerImageFloater";
import { handleSiteHeader } from "./triggers/triggerSiteHeader";

import { stFade } from "./scrolltriggers/stFade";
import { stHero } from "./scrolltriggers/stHero";
// import { stSiteBackground } from "./scrolltriggers/stPageBackground";
import { stPageIntroComplex } from "./scrolltriggers/stPageIntroComplex";
import { stPageIntroStandard } from "./scrolltriggers/stPageIntroStandard";
import { stRotate } from "./scrolltriggers/stRotate";
// import { stSiteHeader } from "./scrolltriggers/stSiteHeader";
import { stSplit } from "./scrolltriggers/stSplit";

window.addEventListener('load', () => {
    
    console.log('JS loaded');

    initScrollSmoother();

    initCookieConsent();

    heroRotator();
    sliderGallery();
    sliderVertical();

    handleHamburgerClick();
    floaterMove();
    floaterShowHide();
    handleImageFloater();
    handleSiteHeader();

    stFade();
    stHero();
    // stSiteBackground();
    stPageIntroComplex();
    stPageIntroStandard();
    stRotate();
    // stSiteHeader();
    stSplit();

});